<template>
  <div>
    <h2>
      Gérez vos transporteurs
    </h2>
    <TransporteurList
      :transporteurs="transporteurs"
      @edit-transporteur="editTransporteur($event)"
      @delete-transporteur="delTransporteur($event)"
      @move-transporteur="mvTransporteur($event)"
      @update-transporteur="upTransporteur($event)"
    />
    <div v-if="!showAddForm">
      <label>
        <button @click="showTransporteurForm">
          Ajouter un Transporteur
        </button>
      </label>
    </div>
    <div v-if="showAddForm">
      <TransporteurForm
        :transporteur="currentTransporteur"
        :forfaits="forfaits"
        :params="parametrages"
        :options="options"
        @validate-add-transporteur="addTransporteur($event)"
        @cancel-add-transporteur="hideTransporteurForm"
      />
    </div>
  </div>
</template>

<script>
import TransporteurList from './atoms/transporteur/TransporteurList.vue'
import TransporteurForm from './atoms/transporteur/TransporteurForm.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    TransporteurList,
    TransporteurForm
  },
  data: function() {
    return {
      showAddForm: false,
      currentTransporteur: {
        params: []
      }
    }
  },
  computed: {
    ...mapGetters([
      'transporteurs',
      'forfaits',
      'parametrages',
      'options'
    ])
  },
  created() {
    this.setForfaits()
    this.setParametrages()
    this.setOptionsTransporteur()
    this.setTransporteurs()
  },
  methods: {
    ...mapActions([
      'createTransporteur',
      'setForfaits',
      'setParametrages',
      'setOptionsTransporteur',
      'setTransporteurs',
      'deleteTransporteur'
      // 'updateTransporteur',
      // 'moveTransporteur'
    ]),
    showTransporteurForm() {
      this.showAddForm = true
    },
    hideTransporteurForm() {
      this.clearCurrentTransporteur()
      this.showAddForm = false
    },
    clearCurrentTransporteur() {
      this.currentTransporteur = { params: [] }
    },
    addTransporteur(transporteur) {
      this.$store.dispatch('createTransporteur', transporteur)
      this.hideTransporteurForm()
      // this.createTransporteur()
    },
    delTransporteur(position) {
      this.$store.dispatch('deleteTransporteur', position)
    },
    editTransporteur(id) {
      this.currentTransporteur = this.transporteurs[id]
      // this.showTransporteurForm()
    },
    upTransporteur(transporteur) {
      // this.updateTransporteur(transporteur)
    },
    mvTransporteur(event) {
      // this.moveTransporteur(event)
    }
  }
}
</script>
